
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon100Call23X = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 303,
  viewBox: "0 0 58 58",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.712 21.284a1.735 1.735 0 0 1 1.05 1.769v10.271a1.53 1.53 0 0 1-1.655 1.667A5.706 5.706 0 0 1 9.4 30.574a7.738 7.738 0 0 1 1.039-6.95c.376-.48.792-.926 1.244-1.336.218-.188.393-.422.513-.685a20.246 20.246 0 0 1 2.842-5.569 16.845 16.845 0 0 1 5.444-4.702 19.23 19.23 0 0 1 4.988-1.963 13.695 13.695 0 0 1 2.042-.32c.76-.065 1.524-.065 2.283 0 1.26.138 2.51.352 3.743.64a16.092 16.092 0 0 1 5.342 2.442 15.19 15.19 0 0 1 4.736 5.124c.776 1.358 1.324 2.842 2.009 4.257.163.326.401.607.696.822a5.957 5.957 0 0 1 2.282 3.526 7.989 7.989 0 0 1-.137 4.874 5.706 5.706 0 0 1-1.928 2.83 1.917 1.917 0 0 0-.662 1.495 15.202 15.202 0 0 1-3.333 7.555 13.604 13.604 0 0 1-3.002 2.66 3.698 3.698 0 0 1-2.807.639 3.755 3.755 0 0 0-1.335 0 .936.936 0 0 0-.628.41c-1.313 2.717-5.604 3.048-7.601 1.222a3.664 3.664 0 0 1-1.347-2.625 3.321 3.321 0 0 1 .845-2.283 5.181 5.181 0 0 1 6.574-.879c.551.42 1.02.938 1.38 1.53.22.36.618.57 1.04.548a8.01 8.01 0 0 0 1.882-.057 5.01 5.01 0 0 0 1.792-1.05 12.417 12.417 0 0 0 3.949-6.312c.057-.217.148-.433.205-.65.057-.217.08-.445.126-.742a8.32 8.32 0 0 0-.925 0 1.518 1.518 0 0 1-1.563-1.518V22.882c0-.687.421-1.303 1.061-1.552A14.357 14.357 0 0 0 28.14 12.2a14.54 14.54 0 0 0-12.428 9.084z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.445 48.994a4.565 4.565 0 0 0 4.76-4.234 4.565 4.565 0 0 0-4.77-4.268 4.565 4.565 0 0 0-4.771 4.268 4.565 4.565 0 0 0 4.781 4.234z",
  fill: "var(--theme-primary, #810ea9)"
}))));

      const __svgRaw = "<svg width=\"300\" height=\"303\" viewBox=\"0 0 58 58\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill-rule=\"nonzero\" fill=\"none\">\r\n        <path d=\"M15.712 21.284a1.735 1.735 0 0 1 1.05 1.769v10.271a1.53 1.53 0 0 1-1.655 1.667A5.706 5.706 0 0 1 9.4 30.574a7.738 7.738 0 0 1 1.039-6.95c.376-.48.792-.926 1.244-1.336.218-.188.393-.422.513-.685a20.246 20.246 0 0 1 2.842-5.569 16.845 16.845 0 0 1 5.444-4.702 19.23 19.23 0 0 1 4.988-1.963 13.695 13.695 0 0 1 2.042-.32c.76-.065 1.524-.065 2.283 0 1.26.138 2.51.352 3.743.64a16.092 16.092 0 0 1 5.342 2.442 15.19 15.19 0 0 1 4.736 5.124c.776 1.358 1.324 2.842 2.009 4.257.163.326.401.607.696.822a5.957 5.957 0 0 1 2.282 3.526 7.989 7.989 0 0 1-.137 4.874 5.706 5.706 0 0 1-1.928 2.83 1.917 1.917 0 0 0-.662 1.495 15.202 15.202 0 0 1-3.333 7.555 13.604 13.604 0 0 1-3.002 2.66 3.698 3.698 0 0 1-2.807.639 3.755 3.755 0 0 0-1.335 0 .936.936 0 0 0-.628.41c-1.313 2.717-5.604 3.048-7.601 1.222a3.664 3.664 0 0 1-1.347-2.625 3.321 3.321 0 0 1 .845-2.283 5.181 5.181 0 0 1 6.574-.879c.551.42 1.02.938 1.38 1.53.22.36.618.57 1.04.548.627.055 1.259.036 1.882-.057a5.01 5.01 0 0 0 1.792-1.05 12.417 12.417 0 0 0 3.949-6.312c.057-.217.148-.433.205-.65.057-.217.08-.445.126-.742a8.32 8.32 0 0 0-.925 0 1.518 1.518 0 0 1-1.563-1.518V22.882c0-.687.421-1.303 1.061-1.552A14.357 14.357 0 0 0 28.14 12.2a14.54 14.54 0 0 0-12.428 9.084z\" fill=\"#000000\"/>\r\n        <path d=\"M30.445 48.994a4.565 4.565 0 0 0 4.76-4.234 4.565 4.565 0 0 0-4.77-4.268 4.565 4.565 0 0 0-4.771 4.268 4.565 4.565 0 0 0 4.781 4.234z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    </g>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-100-call-2@3x.4fb6c2cd58bc240601799c60325ff9fc.svg"),
        {
          React: SvgIcon100Call23X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      